import { useState, useEffect } from 'react'
import { DisburseSum, LoansSum, RepaymentSum } from '../../components';
import { useDispatch, useSelector } from 'react-redux';
import { selectAccessToken } from "../../slices/staffSlice";
import { authStaff } from '../../utils/constants';
import { fetchRequests } from '../../Requests/getRequests';
import { show } from '../../slices/toastSlice';
import { useNavigate } from 'react-router-dom';

function Summary() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const accessToken = useSelector(selectAccessToken);
    const [disburseData, setDisbursedData] = useState({});
    const [repayData, setRepayData] = useState({});
    const [diffLoans, setDiffLoans] = useState({ prev: 0, current: 0 });
    const [days, setDays] = useState({ firstDay: null, lastDay: null });

    useEffect(() => {
        let unsubscribed = false;

        const getLoans = async () => {
            let url = `/loans/staff/stats`;
            let headers = authStaff(accessToken);
            let params = { date: new Date().toISOString().split("T")[0], disbursed: true, incoming: true };
            let res = await fetchRequests(url, "GET", headers, params, {});

            if (res?.code === 401) {
                sessionStorage.clear();
                navigate("/login");
                dispatch(show({ type: "error", state: true, message: "Your session has expired. Please login to continue." }));
                return;
            }
            if (res?.err) {
                dispatch(show({ type: "error", state: true, message: res.err }));
                return;
            }
            if (!unsubscribed) {
                setDisbursedData({ prevTotal: res?.totalDisbursedPrevDay, todayTotal: res?.totalDisbursed });
                setDiffLoans({ prev: res?.totalIncomingPrevDay, current: res?.totalIncoming });
                setRepayData({ todayTotal: res?.totalRepays });
                setDays({ firstDay: res.firstDay, lastDay: res.lastDay });
            }
        };

        getLoans();
        return () => { unsubscribed = true; };
    }, [dispatch, navigate, accessToken]);

    return (
        <div className='section-container md:py-4 py-0'>
            <div className='mb-6'>
                <h1 className='text-2xl font-semibold text-gray-900 dark:text-gray-50'>Dashboard</h1>
                <p className='text-sm text-gray-500 dark:text-gray-400 mt-0.5'>Welcome back — here's what's happening this week.</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <LoansSum diffLoans={diffLoans} days={days} />
                <DisburseSum disburseData={disburseData} days={days} />
                <RepaymentSum repayData={repayData} days={days} />
            </div>
        </div>
    );
}

export default Summary;
